import { DateTime } from 'luxon';

const units = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'];

export const timeAgo = date => {
	let dateTime = DateTime.fromJSDate(date);
	const diff = dateTime.diffNow().shiftTo(...units);
	const unit = units.find(unit => diff.get(unit) !== 0) || 'second';
	if (unit === 'second' && diff.as(unit) < -30) {
		return 'A few seconds ago';
	}
	const relativeFormatter = new Intl.RelativeTimeFormat('en', {
		numeric: 'auto'
	});
	return relativeFormatter.format(Math.trunc(diff.as(unit)), unit as Intl.RelativeTimeFormatUnit);
};
